import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-azure-callback',
    template: '<p>Connexion Microsoft…</p>',
    standalone: true,
})
export class AzureCallbackComponent implements OnInit {
    constructor(
        private msal: MsalService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        const account = this.msal.instance.getActiveAccount();
        if (account) {
            this.router.navigateByUrl('/main');
        } else {
            this.router.navigateByUrl('/');
        }
    }
}
